var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.1 100.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-1{stroke:#00a6e4;stroke-miterlimit:10;stroke-width:4.52px;}.cls-2{fill:#00a6e4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.26,
    y: 64.26,
    width: 14.77,
    height: 33.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,69s16.5-4.78,26.06-2.17c5.32,8,31.38-5,29.1,10.85l13.34-6.25a10.35,10.35,0,0,1,10.92,1.32h0a3.72,3.72,0,0,1,.09,5.73C89,85,70.39,99.75,58.45,98.14,43.2,96.07,26.69,88.91,17,91.84Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.15,
    y1: 60.2,
    x2: 56.88,
    y2: 60.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.29,
    y1: 53.08,
    x2: 62.09,
    y2: 53.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.19,77.72S68,81.63,59.81,81.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51,0a20.55,20.55,0,0,0-9.77,38.62,20.9,20.9,0,0,0-2.49-7.77,15.62,15.62,0,0,1-1.86-2.75A16,16,0,0,1,51,4.52a16,16,0,0,1,14.12,23.6,15.66,15.66,0,0,1-2.06,3,30.27,30.27,0,0,0-3.66,8.22A20.55,20.55,0,0,0,51,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51,4.52A16,16,0,0,0,36.89,28.1a17.51,17.51,0,0,1,1.86,2.75,20.9,20.9,0,0,1,2.49,7.77,25,25,0,0,1,.08,5.07H58.89a15.57,15.57,0,0,1,.52-4.39,30.27,30.27,0,0,1,3.66-8.22,33.86,33.86,0,0,1,2.06-3A16,16,0,0,0,51,4.52ZM45.14,19l3.46,3.44,9.15-9.14,3.19,3.2L48.6,28.79,42,22.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.69,33.81c-2,3.28-4.08,8-3,11.49l.9,2.92H35.84l.68-2.8a19.31,19.31,0,0,0-1.52-12,13.76,13.76,0,0,0-1.75-2.62l3.46-2.91a1.92,1.92,0,0,1,.18.22,17.51,17.51,0,0,1,1.86,2.75,20.9,20.9,0,0,1,2.49,7.77,25,25,0,0,1,.08,5.07H58.89a15.57,15.57,0,0,1,.52-4.39,30.27,30.27,0,0,1,3.66-8.22,33.86,33.86,0,0,1,2.06-3l.16-.21,3.51,2.85A30.15,30.15,0,0,0,66.69,33.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "60.94 16.45 48.6 28.79 41.95 22.15 45.14 18.95 48.6 22.39 57.74 13.25 60.94 16.45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomIcon);
export default __webpack_public_path__ + "static/media/custom-icon.f10778af0842b025927c54201baed45c.svg";
export { ForwardRef as ReactComponent };